<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-contract_setup'"
    :addButton="false"
  >
    <Dropdown2
      :label="$t('recoupable_type')"
      :placeholder="$t('recoupable_type')"
      :options="selectedContractDetails.costSplitTypesTV"
      :selected="
        selectedContractDetails.costSplitTypesTV.find(
          (e) => e.value == selectedContractDetails.contract.cost_split_type
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('cost_split_type', e)"
    />

    <div class="ut-flex">
      <TextField2
        :ta="'right'"
        :id="'cost_split_percent'"
        :type="'percent'"
        :placeholder="$t('share')"
        :label="$t('share')"
        :value="selectedContractDetails.contract.cost_split_percent"
        :bb="'none'"
        :cw="`clamp(60px, ${
          (
            (selectedContractDetails &&
              selectedContractDetails.contract &&
              selectedContractDetails.contract.cost_split_percent) ||
            ''
          ).toString().length * 11
        }px, 250px)`"
        @blur="onTextFieldValueChange"
      />
    </div>

    
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

export default {
  components: {
    DBox,
  },
  data: function () {
    return {
      disabled: false,
    };
  },
  props: ["selectedContractDetails"],
  computed: {
    autofetchProjectTV: function () {
      return [
        { text: "On", value: 1 },
        { text: "Off", value: 2 },
      ];
    },
    statuses: function () {
      return this.selectedContractDetails?.label_statuses || [];
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },

    onDateUpdate: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onCheckboxChange: function (name, value) {
      value = value.target.checked ? "1" : "0";
      this[name] = value;
      this.$emit("changed", { name, value });
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-contract_setup {
  .setup-row {
    padding: 0 0 0 10px;
    --bb: 1px solid var(--sprt-85);
    height: 30px;
    min-height: 30px;
    border-bottom: var(--bb);

    &.no-border {
      border-bottom-color: transparent;
    }

    .label-title,
    .icon,
    .title {
      flex: 1;
    }
    .label-title,
    .title-txt {
      max-width: 115px;
      color: var(--text-5);
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.flex-auto,
      &.no-right-padding {
        padding-left: 21px;
      }

      &.flex-auto {
        flex: 0 1 auto;
      }

      &.no-right-padding {
        padding-right: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }

    .dropdown-2 {
      flex: 1;
    }

    .no-label {
      .label-title {
        display: none;
      }
    }
    .circle {
      margin-right: 10px;
    }
    .flex-grow {
      flex-grow: 1;
    }
  }
}
</style>
